import React, { useCallback, useEffect, useState } from 'react';
import { FormikValues } from 'formik';

import { stripTags } from 'app/utils';

const UseFormikHandles = (formik: FormikValues) => {
  const [formikFieldFocused, setFormikFieldFocused] = useState<string | null>(null);

  const [formikFieldsLength, setFormikFieldsLength] = useState<Record<string, number>>(undefined!);

  useEffect(() => {
    setFormikFieldsLength(
      Object.keys(formik.values).reduce((prev, field) => {
        const value = formik && formik.values && formik.values[field];
        return value
          ? { ...prev, [field]: stripTags(value).trim().length }
          : { ...prev, [field]: 0 };
      }, {})
    );
  }, [formik.values]);

  return {
    formikFieldFocused,
    formikFieldsLength,
    formikSetFieldFocused: useCallback(
      (fieldFocused: string | null) =>
        setFormikFieldFocused(fieldFocused === formikFieldFocused ? null : fieldFocused),
      [formikFieldFocused]
    ),

    formikHandleFocus: (
      event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
    ) => {
      if (event.target.hasAttribute('data-preventautocomplete'))
        event.target.removeAttribute('readonly');

      // formik.handleFocus(event);
      setFormikFieldFocused(event.target.name);
    },

    formikHandleBlur: (
      event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
    ) => {
      if (event.target.hasAttribute('data-preventautocomplete'))
        event.target.setAttribute('readonly', 'readonly');

      formik.handleBlur(event);
      setFormikFieldFocused(null);
    },

    formikHandleChange: (
      event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
    ) => {
      setFormikFieldsLength((prev) => ({
        ...prev,
        [event.target.name]: event.target.value.length,
      }));
      formik.handleChange(event);
    },

    formikFieldLengthChange: useCallback(
      (field: string, value: any) => {
        setFormikFieldsLength((prev) => ({
          ...prev,
          [field]: stripTags(value).trim().length,
        }));
      },
      [formikFieldsLength]
    ),
  };
};

export default UseFormikHandles;
